import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import Grid from '@mui/material/Grid2';
import { ReactFitty } from 'react-fitty';
import TransitEnterexitIcon from '@mui/icons-material/TransitEnterexit';
import img1 from '../../assets/img/project1Page/img1.png'
import img2 from '../../assets/img/project1Page/img2.png'

const Project1 = () => {
  return (
    <Box height={"100dvh"}>
      <Link href={'https://admin.greenavi.com'} target={'_blank'}>
        <Box sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          backgroundColor: '#fd4002',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <TransitEnterexitIcon sx={{
            fontSize: '4rem',
            color: '#191b1e',
            '@media screen and (max-width: 600px)': {
              fontSize: '2rem',
            }
          }} />
        </Box>
      </Link>
      <Box sx={{
        padding: '100px',
        // height: '20%',
        borderBottom: '4px solid #fd4002',
        '@media screen and (max-width: 600px)': {
          padding: '40px',
        }
      }}>
        <Typography
          color='primary'
          sx={{ textAlign: 'center', position: 'relative', zIndex: 2, lineHeight: 0.7 }}
          component={ReactFitty}
        >
          ПРОЦЕССИНГ КРИПТОПЛАТЕЖЕЙ
        </Typography>
        <Typography
          sx={{
            fontFamily: "Great Vibes",
            textAlign: 'left',
            position: 'relative',
            zIndex: 3,
            width: '100%',
            fontSize: '4rem',
            padding: '0 30px',
            marginTop: '-30px',
            lineHeight: 0.7,
            color: '#fd4002',
            '@media screen and (max-width: 600px)': {
              fontSize: '2rem',
              marginTop: '-20px',
            }
          }}>
          Project 01
        </Typography>
      </Box>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: '#191b1e',
          zIndex: 1,
          position: 'relative',
          marginTop: '-130px',
          height: '85%',
          '@media screen and (max-width: 600px)': {
            marginTop: '-54px',
          }
        }}
      >
        <Grid size={7} sx={{
          height: '100%',
          '@media screen and (max-width: 1200px)': {
            display: 'none'
          }
        }}>
          <img src={img1} alt="exmpl-img" style={{ height: '100%', width: '100%' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <Box sx={{
              height: '100%',
              overflow: 'hidden',
              '& img': {
                '@media screen and (max-width: 1200px)': {
                  width: '200% !important'
                }
              }
            }}>
              <img src={img2} alt="exmpl-img" style={{ height: '100%', width: '100%' }} />
            </Box>
            <Grid container spacing={0}>
              <Grid size={11}
                sx={{
                  padding: "50px",
                  '@media screen and (max-width: 600px)': {
                    padding: '20px'
                  }
                }}>
                <Typography
                  color='primary'
                  gutterBottom
                  sx={{
                    '@media screen and (max-width: 600px)': {
                      fontSize: '0.8rem'
                    }
                  }}
                >
                  Криптовалютный процессинг
                </Typography>
                <Typography
                  color='primary'
                  gutterBottom
                  sx={{
                    '@media screen and (max-width: 600px)': {
                      fontSize: '0.8rem'
                    }
                  }}
                >
                  Разработан надёжный и удобный сервис для приема криптовалютных платежей, обеспечивающий безопасные и быстрые транзакции.
                </Typography>
                <Typography
                  color='primary'
                  gutterBottom
                  sx={{
                    '@media screen and (max-width: 600px)': {
                      fontSize: '0.8rem'
                    }
                  }}
                >
                  Система спроектирована с учетом масштабируемости и отказоустойчивости, обеспечивая стабильную работу при высокой нагрузке.
                </Typography>
              </Grid>
              <Grid size={1} sx={{ backgroundColor: '#fd4002' }}></Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Project1